import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import { T, Icon, stitchOutlineBtn, stitchTooltipSlotProps } from '../ProjectOverview/parts/stitch';

/**
 * Status van de AI-check op een klantbriefing-kaart:
 * bezig → "AI-check loopt…", klaar → knop "Briefing-check", mislukt → "opnieuw proberen".
 * (Een check die na een herstart bleef hangen, geeft de engine na 5 min als mislukt.)
 */
function BriefingCheckStatus({ doc, bezigMetKnop = false, onBekijk, onOpnieuw }) {
  const status = doc?.analyse_status || (doc?.analyse_markdown ? 'klaar' : 'mislukt');
  const knop = { ...stitchOutlineBtn, py: 0.4, fontSize: '0.75rem' };

  if (status === 'bezig') {
    return (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }} role="status">
        <CircularProgress size={13} />
        <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.secondary }}>
          Opgeslagen · AI-check loopt…
        </Typography>
      </Box>
    );
  }
  if (status === 'klaar' && doc?.analyse_markdown) {
    return (
      <Box component="span" sx={knop} onClick={onBekijk}>
        <Icon name="fact_check" size={15} /> Briefing-check
      </Box>
    );
  }
  return (
    <Tooltip title={doc?.analyse_fout || 'De AI-check is niet gelukt'} slotProps={stitchTooltipSlotProps}>
      <Box component="span" sx={{ ...knop, opacity: bezigMetKnop ? 0.6 : 1 }} onClick={onOpnieuw}>
        <Icon name="auto_awesome" size={15} /> AI-check mislukt · opnieuw proberen
      </Box>
    </Tooltip>
  );
}

export default BriefingCheckStatus;
